import { getRequestConfig } from 'next-intl/server';
import { defaultLocale, defaultTimeZone, type Locale, locales } from './locales';

export { defaultLocale, defaultTimeZone, locales, type Locale };

export function isValidLocale(value: string): value is Locale {
  return (locales as ReadonlyArray<string>).includes(value);
}

export default getRequestConfig(async ({ requestLocale }) => {
  const requested = await requestLocale;
  const locale = requested && isValidLocale(requested) ? requested : defaultLocale;

  return {
    locale,
    timeZone: defaultTimeZone,
    messages: (await import(`./locales/${locale}.json`)).default,
  };
});
